// extracted by mini-css-extract-plugin
export default {"settings":"style_settings__N0ofY"};